// extracted by mini-css-extract-plugin
module.exports = {"CalendarHeaderDay":"index-shimmer_CalendarHeaderDay__1rvWh","placeholderShimmer":"index-shimmer_placeholderShimmer__32Ei8"};